import { FavoriteGroupSourceEnum, type ForManagerLocationDetail } from "@sidegigllc/api/client";
import { proGroupsQueryOptions } from "api/queries/proGroups";
import type { WarmableQuery } from "routing/warmQueries";

// `allSources`: the one-kind-of-group flag is on, so the list is not narrowed to a source.
type QueriesInput = {
  location: ForManagerLocationDetail | undefined;
  source?: FavoriteGroupSourceEnum;
  allSources?: boolean;
};

export const groupsQuery = ({ location, source = FavoriteGroupSourceEnum.MARKETPLACE, allSources }: QueriesInput) =>
  proGroupsQueryOptions(
    {
      organization_id: location?.organization_id,
      market_id: location?.market_id,
      source: allSources ? undefined : source,
    },
    { enabled: location != null },
  );

export const queries = (input: QueriesInput): Array<WarmableQuery> => [groupsQuery(input)];
